<script setup lang="ts">
import MmIcon from './MmIcon.vue'
import type { MmIconName } from './icons'
withDefaults(defineProps<{ message: string; type?: 'mint' | 'warn' | 'err'; icon?: MmIconName; action?: string }>(), { type: 'mint', icon: 'check' })
const emit = defineEmits<{ action: [] }>()
</script>

<template><div class="toast" :class="type" :role="type === 'err' ? 'alert' : 'status'" aria-atomic="true"><MmIcon :name="icon" :size="18" /><span>{{ message }}</span><button v-if="action" type="button" class="toast-action" @click="emit('action')">{{ action }}</button></div></template>
